import React, { Component } from "react";
import styles from "./VehicleSpecs.module.scss";
import sharedStyles from "../OrderDetailsNewVersion.module.scss";
import crStyles from "../../../customerReservation/crStyles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Grid from "@material-ui/core/Grid";
import { GetFloatToFixedValue } from "../../../../utils/GetFloatValue";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../../../shared/ExpansionPanels/ExpansionPanel";
import { REG_FEE } from "../../../../common/Constants";
import { NOTNULL_OR_NOTUNDEFINED } from "../../../../utils/EmpUtil";
import { withTranslation } from "react-i18next";

class VehicleSpecsHercules extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandSpecsInfo: false,
    };
  }

  expandCustomerInfo() {
    this.setState((prevState) => ({
      expandSpecsInfo: !prevState.expandSpecsInfo,
    }));
  }

  formatPriceValue(value) {
    const defaultCurrency = this.props.defaultCurrency;
    if (NOTNULL_OR_NOTUNDEFINED(value)) {
      value = GetFloatToFixedValue(value, 2);
      value = value.toString();
      value =
        value.charAt(0) === "+" || value.charAt(0) === "-"
          ? value.charAt(0).concat(defaultCurrency, value.substr(1))
          : defaultCurrency.concat(value);
    } else {
      value = "--";
    }
    return value;
  }

  specsRow(styling, displayText, secondText, key = "") {
    return (
      displayText && (
        <Grid container key={key === "" ? displayText : key}>
          <Grid item xs={11} className={styling}>
            <div>{displayText}</div>
          </Grid>
          <Grid item xs={1} className={styling}>
            {secondText && (
              <div className={styles.priceValue}>{secondText}</div>
            )}
          </Grid>
        </Grid>
      )
    );
  }

  render() {
    const pricingStack = this.props.pricingStack;
    const allAccessories = this.props.allAccessories;
    return (
      <StyledBasicExpansionPanel
        expanded={
          this.props.offlinePricingUpdate.partialOffline
            ? false
            : this.state.expandSpecsInfo
        }
        disabled={this.props.offlinePricingUpdate.partialOffline}
        onChange={() => this.expandCustomerInfo()}
      >
        <StyledBasicExpansionPanelSummary
          style={crStyles.headerBarNeutral}
          id="exp"
        >
          <div className={sharedStyles.headerBar}>
            <div className={sharedStyles.boldHeader}>
              {this.props.offlinePricingUpdate.partialOffline
                ? this.props.t(
                    "CustomerOrderDetails.vehicleSpecsHeaderPricingAgreed"
                  )
                : this.props.t("CustomerOrderDetails.vehicleSpecsHeader")}
            </div>
            {!this.props.offlinePricingUpdate.partialOffline &&
              (this.state.expandSpecsInfo ? (
                <ExpandLessIcon id="less" />
              ) : (
                <ExpandMoreIcon id="more" />
              ))}
          </div>
          <br />
        </StyledBasicExpansionPanelSummary>

        <div className={styles.vehicleInfoGrid}>
          <div className={styles.bottomBorder} />

          {pricingStack ? (
            <Grid container className={styles.specsContainer}>
              {this.specsRow(
                styles.lightHeader,
                this.props.t("VehicleSpecs.basePrice"),
                this.formatPriceValue(
                  pricingStack.basePriceWithVehicleRegistrationTax
                )
              )}
              {pricingStack.registrationTaxBase !== null &&
                this.specsRow(
                  styles.darkHeader,
                  this.props.t("VehicleSpecs.registrationTaxBase"),
                  this.formatPriceValue(pricingStack.registrationTaxBase)
                )}
              {pricingStack.dealerOTRCosts &&
                Object.keys(pricingStack.dealerOTRCosts)
                  .filter((price) => price === REG_FEE)
                  .map((price) => {
                    return this.specsRow(
                      styles.lightHeader,
                      this.props.t("VehicleSpecs.regFee"),
                      this.formatPriceValue(pricingStack.dealerOTRCosts[price])
                    );
                  })}
              {this.specsRow(
                styles.darkHeader,
                this.props.t("VehicleSpecs.configureOptions"),
                this.formatPriceValue(pricingStack.selectedFeaturePrice)
              )}
              {pricingStack.userSelectedFeatures &&
                pricingStack.userSelectedFeatures.map((feature, index) =>
                  this.specsRow(
                    styles.darkIndentDetails,
                    feature.type,
                    this.formatPriceValue(feature.value),
                    index
                  )
                )}
              {pricingStack.registrationTaxOnOptions !== null &&
                this.specsRow(
                  styles.lightHeader,
                  this.props.t("VehicleSpecs.registrationTaxOnOptions"),
                  this.formatPriceValue(pricingStack.registrationTaxOnOptions)
                )}
              {pricingStack.grossRetailWithVehicleRegistrationTax !== null &&
                this.specsRow(
                  styles.darkHeader,
                  this.props.t("VehicleSpecs.registrationTaxOnOptionsBpm"),
                  this.formatPriceValue(
                    pricingStack.grossRetailWithVehicleRegistrationTax
                  )
                )}
              <>
                {this.specsRow(
                  styles.lightHeader,
                  this.props.t("VehicleSpecs.unavoidableCost"),
                  this.formatPriceValue(pricingStack.unavoidableCostTotalGross)
                )}
                {this.specsRow(
                  styles.darkHeader,
                  this.props.t(
                    "PassengerVehicleSpecsHercules.totalRetailPrice"
                  ),
                  this.formatPriceValue(pricingStack.grossRetailWithOTR)
                )}
                {this.specsRow(
                  styles.lightHeader,
                  this.props.t("PassengerVehicleSpecsHercules.fordPromotion1"),
                  this.formatPriceValue(pricingStack.customerSaving)
                )}
                {this.specsRow(
                  styles.darkHeader,
                  this.props.t(
                    "PassengerVehicleSpecsHercules.accessoriesInclFitting"
                  ),
                  this.formatPriceValue(allAccessories.totalPrice)
                )}
                {allAccessories &&
                  allAccessories.accessoriesList.map((accessory, index) =>
                    this.specsRow(
                      styles.darkIndentDetails,
                      accessory.description,
                      this.formatPriceValue(accessory.price),
                      index
                    )
                  )}
                {this.specsRow(
                  styles.lightHeader,
                  this.props.t(
                    "PassengerVehicleSpecsHercules.totalPriceInclVatBpm"
                  ),
                  this.formatPriceValue(pricingStack.totalPriceWithAddOns)
                )}
                {this.specsRow(
                  styles.lightIndentDetails,
                  this.props.t("VehicleSpecs.ofVAT"),
                  this.formatPriceValue(
                    pricingStack.vatAmountWithOTRAndIncentivesAndAccessories
                  )
                )}
                {this.specsRow(
                  styles.lightIndentDetails,
                  this.props.t(
                    "PassengerVehicleSpecsHercules.vehicleTaxIncOptions"
                  ),
                  this.formatPriceValue(pricingStack.registrationTax)
                )}
                {this.specsRow(
                  styles.lightIndentDetails,
                  this.props.t(
                    "PassengerVehicleSpecsHercules.totVehPriceWithRegTax"
                  ),
                  this.formatPriceValue(
                    pricingStack.grossRetailWithVehicleRegistrationTax
                  )
                )}
                {this.props.tradeIn &&
                  this.specsRow(
                    styles.darkHeader,
                    this.props.t("PassengerVehicleSpecsHercules.tradeIn"),
                    this.formatPriceValue(pricingStack.trueNetValue)
                  )}
                {this.specsRow(
                  styles.lightHeader,
                  this.props.t("VehicleSpecs.totalPriceIncVatTradeIn"),
                  this.formatPriceValue(pricingStack.totalAmountPayable)
                )}
              </>
            </Grid>
          ) : (
            <span className={styles.labelError}>
              {this.props.t("CustomerOrderDetails.errorLoadingDetails")}
            </span>
          )}
        </div>
      </StyledBasicExpansionPanel>
    );
  }
}

export default withTranslation("emp")(VehicleSpecsHercules);
